// It is important to choose an enum key that is in the native language (with proper capitlization as well)
// We use this key in a few places (display current language name, language select radio buttons)
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Svenska"] = "sv";
    LanguageCode["English"] = "en";
    LanguageCode["Latvie\u0161u"] = "lv";
})(LanguageCode || (LanguageCode = {}));
//# sourceMappingURL=language-codes.js.map